import {
  CircleF,
  GoogleMap,
  MarkerF,
  PolygonF,
  PolylineF,
  RectangleF,
  useJsApiLoader,
} from "@react-google-maps/api";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  DDtoDMS,
  appURL,
  bearing,
  decodeHtml,
  deleteTooltip,
  distanceFrom,
  drawArc,
  format,
  formatDate,
  googleMapsApiKey,
  injectTooltip,
  logo,
  mapOptions,
  moveTooltip,
  navareaIndicator,
  navareaLineOne,
  navareaLineTwo,
  navtexIndicator,
  params,
  tnpIndicator,
  toChartCord,
} from "./utils";
import Cookies from "universal-cookie";
import axios from "axios";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import Loader from "./loader";
import { GiArrest } from "react-icons/gi";
import generateNavtexPdf from "./component/indiaWinsPdf";
import { FiDownload } from "react-icons/fi";

function App() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [renderOption, setRenderOption] = useState([]);
  const [hideInfo, setHideInfo] = useState(true);
  const cookies = new Cookies();
  const [showAllCharts, setShowAllCharts] = useState(false);
  const [currentWarningData, setCurrentWarningData] = useState(null);
  const [currentWarningCharts, setCurrentWarningCharts] = useState(null);
  const [currentWarningEncs, setCurrentWarningEncs] = useState(null);
  const [width, setWidth] = useState(window.innerWidth);
  const [showSidebar, setShowSidebar] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [searchByNumber, setSearchByNumber] = useState(false);
  const [searchOptions, setSearchOptions] = useState({
    number: { enabled: false, value: "" },
    date: { enabled: false, value: "" },
  });
  const sidebarRef = useRef();
  const [yearNavTex, setYearNavTex] = useState();
  const [selectedType, setSelectedType] = useState("");
  const [identifier, setIdentifier] = useState();
  const [navDate, setNavDate] = useState();
  const [filterYearData, setFilterYearData] = useState();
  const [viewData, setViewData] = useState();
  const [selectedPolygonId, setSelectedPolygonId] = useState(null);
  const coordsRef = useRef(null);
  const ENABLE_TNP = false;

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const identifier = params.get("identifier");
    const type = params.get("type");

    if (!identifier || !type) {
      console.warn("Missing identifier or type in URL params!");
      return;
    }

    let sourceArray = [];

    if (type === "navTax" && Array.isArray(data?.NavTex)) {
      sourceArray = data.NavTex;
    } else if (type === "navArea" && Array.isArray(data?.NavArea)) {
      sourceArray = data.NavArea;
    } else {
      console.warn("Invalid type or data structure!");
      return;
    }

    const matchingItems = sourceArray.filter(
      (item) => item.identifier == identifier
    );
    if (matchingItems.length > 0) {
      let charts = matchingItems[0].charts;
      charts = JSON.parse(charts);
      let filteredCharts = allCharts?.filter((item) =>
        charts.includes(item.id)
      );
      let allFilteredChartNo = filteredCharts?.map((item) => item.chartNo);
      let filteredEncs = allEncs?.filter((item) =>
        allFilteredChartNo?.includes(item.chartNum)
      );
      setCurrentWarningEncs(filteredEncs);
      setCurrentWarningCharts(filteredCharts);
      setCurrentWarningData(matchingItems[0]);
      setHideInfo(false);
    } else {
      console.error("No matching data found!");
    }
  }, [data]);
  useEffect(() => {
    if (hideInfo) {
      setSelectedPolygonId(null);
    }
  }, [hideInfo]);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let token = cookies.get("X-ACCESS-TOKEN");
  useEffect(() => {
    if (token) {
      getWarningsData(token);
    } else {
      getAuthToken();
    }
  }, []);

  useEffect(() => {
    if (error) {
      console.error(error);
    }
  }, [error]);

  const getAuthToken = async () => {
    try {
      const response = await axios.post(`${appURL}/o/oauth2/token`, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
      });

      if (response.data.access_token) {
        cookies.set("X-ACCESS-TOKEN", response.data.access_token, {
          sameSite: "strict",
          path: "/",
          expires: new Date(new Date().getTime() + 60 * 60 * 24 * 1000),
        });
        getWarningsData(response.data.access_token);
      } else {
        setError("Token not available.");
        console.warn("Unable to generate access token.");
      }
    } catch (err) {
      setError(err);
    }
  };

  const getWarningsData = async (token) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${appURL}/o/nho-headless/map/combined`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const [{ NavTex }, { NavArea }, { NAVTP }, { OCCharts }, { ENCCharts }] =
        response.data;
      // response.data;
      setData({ NavTex, NavArea, NAVTP, OCCharts, ENCCharts });
      setLoading(false);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        getAuthToken();
      } else {
        setError(err);
        setLoading(false);
      }
    }
  };

  const allNavarea = useMemo(() => {
    return data &&
      data.NavArea &&
      Array.isArray(data.NavArea) &&
      data.NavArea.length > 0
      ? data.NavArea.map((item) => {
          try {
            let coordinates = JSON.parse(item.coordinates);
            if (
              coordinates &&
              Array.isArray(coordinates) &&
              coordinates.length > 0
            ) {
              let coordinatesCopy = [...coordinates];
              coordinates = coordinatesCopy.map((item) => ({
                lat: DDtoDMS(item.lat),
                lng: DDtoDMS(item.long),
              }));
            } else {
              coordinates = [];
            }
            return { ...item, coordinates, key: "navarea" };
          } catch (err) {
            return { ...item, key: "navarea" };
          }
        })
      : [];
  }, [data]);

  const allNavtex = useMemo(() => {
    return data &&
      data.NavTex &&
      Array.isArray(data.NavTex) &&
      data.NavTex.length > 0
      ? data.NavTex.map((item) => {
          try {
            let coordinates = JSON.parse(item.coordinates);
            if (
              coordinates &&
              Array.isArray(coordinates) &&
              coordinates.length > 0
            ) {
              let coordinatesCopy = [...coordinates];
              coordinates = coordinatesCopy.map((item) => ({
                lat: DDtoDMS(item.lat),
                lng: DDtoDMS(item.long),
              }));
            } else {
              coordinates = [];
            }
            return { ...item, coordinates, key: "navtex" };
          } catch (err) {
            return { ...item, key: "navtex" };
          }
        })
      : [];
  }, [data]);

  const allTNP = useMemo(() => {
    return data &&
      data.NAVTP &&
      Array.isArray(data.NAVTP) &&
      data.NAVTP.length > 0
      ? data.NAVTP.map((item) => {
          try {
            let coordinates = JSON.parse(item.coordinates);
            if (
              coordinates &&
              Array.isArray(coordinates) &&
              coordinates.length > 0
            ) {
              let coordinatesCopy = [...coordinates];
              coordinates = coordinatesCopy.map((item) => ({
                lat: DDtoDMS(item.lat),
                lng: DDtoDMS(item.long),
              }));
            } else {
              coordinates = [];
            }
            return { ...item, coordinates, key: "t_p_notices" };
          } catch (err) {
            return { ...item, key: "t_p_notices" };
          }
        })
      : [];
  }, [data]);

  const allCharts = useMemo(() => {
    return data &&
      data.OCCharts &&
      Array.isArray(data.OCCharts) &&
      data.OCCharts.length > 0
      ? data.OCCharts
      : [];
  }, [data]);
  const allEncs = useMemo(() => {
    return data &&
      data.ENCCharts &&
      Array.isArray(data.ENCCharts) &&
      data.ENCCharts.length > 0
      ? data.ENCCharts
      : [];
  }, [data]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googleMapsApiKey,
  });

  const mapContainerStyle = {
    width: "100%",
    height: width < 1024 ? `calc(100vh - 60px)` : "100vh",
  };

  const allPoints = useMemo(() => {
    let allNavareaPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("navarea"))
        ? allNavarea.filter((item) => item.feature == "point")
        : [];
    let allNavtexPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("navtex"))
        ? allNavtex.filter((item) => item.feature == "point")
        : [];
    let allTNPPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("t_p_notices"))
        ? allTNP.filter((item) => item.feature == "point")
        : [];
    return ENABLE_TNP
  ? [...allNavareaPoints, ...allNavtexPoints, ...allTNPPoints]
  : [...allNavareaPoints, ...allNavtexPoints];
  }, [allNavarea, allNavtex, allTNP, renderOption]);

  const allPolygon = useMemo(() => {
    let allNavareaPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("navarea"))
        ? allNavarea.filter((item) => item.feature == "polygon")
        : [];
    let allNavtexPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("navtex"))
        ? allNavtex.filter((item) => item.feature == "polygon")
        : [];
    let allTNPPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("t_p_notices"))
        ? allTNP.filter((item) => item.feature == "polygon")
        : [];
    return ENABLE_TNP
  ? [...allNavareaPoints, ...allNavtexPoints, ...allTNPPoints]
  : [...allNavareaPoints, ...allNavtexPoints];
  }, [allNavarea, allNavtex, allTNP, renderOption]);

  const allArcs = useMemo(() => {
    let allNavareaPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("navarea"))
        ? allNavarea.filter((item) => item.feature == "arc")
        : [];
    let allNavtexPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("navtex"))
        ? allNavtex.filter((item) => item.feature == "arc")
        : [];
    let allTNPPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("t_p_notices"))
        ? allTNP.filter((item) => item.feature == "arc")
        : [];
    return ENABLE_TNP
  ? [...allNavareaPoints, ...allNavtexPoints, ...allTNPPoints]
  : [...allNavareaPoints, ...allNavtexPoints];
  }, [allNavarea, allNavtex, allTNP, renderOption]);

  const allCircles = useMemo(() => {
    let allNavareaPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("navarea"))
        ? allNavarea.filter((item) => item.feature == "circle")
        : [];
    let allNavtexPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("navtex"))
        ? allNavtex.filter((item) => item.feature == "circle")
        : [];
    let allTNPPoints =
      renderOption &&
      Array.isArray(renderOption) &&
      (renderOption.length === 0 || renderOption.includes("t_p_notices"))
        ? allTNP.filter((item) => item.feature == "circle")
        : [];
    return [
      ...allNavareaPoints,
      ...allNavtexPoints,
      ...allTNPPoints,
      renderOption,
    ];
  }, [allNavarea, allNavtex, allTNP, renderOption]);

  const allMisc = useMemo(() => {
    let allNavareaPoints = allNavarea.filter((item) => item.feature == "misc");
    let allNavtexPoints = allNavtex.filter((item) => item.feature == "misc");
    let allTNPPoints = allTNP.filter((item) => item.feature == "misc");
    return ENABLE_TNP
  ? [...allNavareaPoints, ...allNavtexPoints, ...allTNPPoints]
  : [...allNavareaPoints, ...allNavtexPoints];
  }, [allNavarea, allNavtex, allTNP]);

  // Handle Warning render functions

  const handleWarningToggle = (e) => {
    let value = e.target.value;
    let checked = e.target.checked;
    if (value == "all") {
      if (checked) {
        setRenderOption(
          ENABLE_TNP
            ? ["navarea", "navtex", "t_p_notices", "misc"]
            : ["navarea", "navtex", "misc"]
        );
        setCurrentWarningData("");
        setHideInfo(true);
        setSelectedType();
        setSearchOptions({
          number: {
            enabled: false,
            value: "",
          },
          date: {
            enabled: false,
            value: "",
          },
        });
      } else {
        setRenderOption([]);
      }
    } else {
      if (checked) {
        if (!renderOption.includes(value)) {
          let filterdOption = [...renderOption];
          filterdOption.push(value);
          setRenderOption(filterdOption);
        }
      } else {
        let filterdOption = renderOption.filter((item) => item !== value);
        setRenderOption(filterdOption);
      }
    }

    if (width < 1024) {
      setShowSidebar((prev) => !prev);
    }
  };

  const allChecked = useMemo(() => {
    return ENABLE_TNP
  ? renderOption.includes("navarea") &&
      renderOption.includes("navtex") &&
      renderOption.includes("t_p_notices") &&
      renderOption.includes("misc")
  : renderOption.includes("navarea") &&
      renderOption.includes("navtex") &&
      renderOption.includes("misc");
  }, [renderOption]);

  function handleMouseOver(props, e, title) {
    props.setOptions({ fillOpacity: 0.6 });
    injectTooltip(e, title);
  }

  function handleMouseOut(e) {
    this.setOptions({ fillOpacity: 0.35 });
    deleteTooltip(e);
  }

  function handleRecMouseOver(props, e, title) {
    props.setOptions({ fillOpacity: 0.2 });
    injectTooltip(e, title);
  }

  function handleRecMouseOut(e) {
    this.setOptions({ fillOpacity: 0 });
    deleteTooltip(e);
  }

  const showWarningData = (data) => {
    let {
      date,
      identifier,
      types,
      dtg,
      b_char,
      general_area,
      station,
      place,
      notice,
      message,
      charts,
      key,
    } = data;

    if (charts && charts !== "") {
      try {
        charts = JSON.parse(charts);
        let filteredCharts = allCharts.filter((item) =>
          charts.includes(item.id)
        );
        let allFilteredChartNo = filteredCharts.map((item) => item.chartNo);
        let filteredEncs = allEncs.filter((item) =>
          allFilteredChartNo.includes(item.chartNum)
        );
        setCurrentWarningEncs(filteredEncs);
        setCurrentWarningCharts(filteredCharts);
        setSelectedType("");
        setSearchOptions({
          number: {
            enabled: false,
            value: "",
          },
          date: {
            enabled: false,
            value: "",
          },
        });
      } catch (err) {
        console.warn("Unexpected JSON in Chart");
      }
    } else {
      setCurrentWarningCharts(null);
    }
    setShowAllCharts(false);
    setCurrentWarningData({
      date,
      identifier,
      types,
      dtg,
      b_char,
      general_area,
      station,
      place,
      notice,
      message,
      key,
    });
    if (hideInfo) {
      setHideInfo(false);
    }
    // Set selected polygon id to filter polygons visible on map
    setSelectedPolygonId(data.identifier);
    window.history.pushState({}, "", "/india-wins");
    document.getElementById("pills-home-tab").click();
  };

  const showChartsData = (data) => {
    let filteredEncs = allEncs.filter((item) => item.chartNum == data.chartNo);
    setCurrentWarningEncs(filteredEncs);
    setCurrentWarningCharts([data]);
    if (hideInfo) {
      setHideInfo(false);
    }
    document.getElementById("pills-profile-tab").click();
  };

  const renderAllCharts = (check) => {
    if (check) {
      setShowAllCharts(true);
      setCurrentWarningData("");
      setHideInfo(true);
      setSelectedType("");
    } else {
      setShowAllCharts(false);
    }
    if (width < 1024) return setShowSidebar((prev) => !prev);
  };

  const wrapperClass = useMemo(() => {
    return width < 1024 && showSidebar ? "india-wins-md-wrapper" : "";
  });

  const handleOnBlur = (event) => {
    if (event.target === sidebarRef.current) {
      setShowSidebar((prev) => !prev);
    } else {
      event.stopPropagation(); // Prevent bubbling to parent if clicked on child
    }
  };
  const gettingNewData = async () => {
    try {
      const res = await axios.get(`${appURL}/o/nho-headless/map/combined`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const getNavType = Array.isArray(res.data)
        ? res.data.filter((item) => Object.keys(item)[0] === selectedType)
        : [];

      const navItems = getNavType.length > 0 ? getNavType[0][selectedType] : [];
      const filteredByYear = Array.isArray(navItems)
        ? navItems.filter(
            (item) => new Date(item.date).getFullYear() == selectedYear
          )
        : [];
      setFilterYearData(
        Array.isArray(filteredByYear) && filteredByYear.length > 0
          ? [...filteredByYear]
          : []
      );
      const navNumber =
        filteredByYear &&
        Array.isArray(filteredByYear) &&
        filteredByYear.length > 0 &&
        filteredByYear.map((item) => item.identifier);
      const navDate =
        filteredByYear &&
        Array.isArray(filteredByYear) &&
        filteredByYear.length > 0 &&
        filteredByYear.map((item) => item.date);
      setIdentifier(
        Array.isArray(navNumber) && navNumber.length > 0 ? [...navNumber] : []
      );
      setNavDate(
        Array.isArray(navDate) && navDate.length > 0 ? [...navDate] : []
      );
    } catch (error) {
      console.error(error, "erorr error");
    }
  };

  useEffect(() => {
    gettingNewData();
  }, [selectedType, selectedYear]);

  const handleTypeChange = (type) => {
    setSelectedType((prev) => (prev === type ? "" : type));
    setSelectedYear(new Date().getFullYear());
    setSearchOptions((prev) => ({
      number: {
        enabled: false,
      },
      date: {
        enabled: false,
      },
    }));
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value, "check the year value");
    // You can pass the selected year to a parent or use it for filtering
  };

  const years = [];
  for (let year = new Date().getFullYear(); year >= 2000; year--) {
    years.push(year);
  }

  const handleCheckboxChange = (key) => (e) => {
    const isChecked = e.target.checked;

    setSearchOptions((prev) => ({
      number: {
        ...prev.number,
        enabled: key === "number" ? isChecked : false,
        value: key === "number" && isChecked ? prev.number.value : "",
      },
      date: {
        ...prev.date,
        enabled: key === "date" ? isChecked : false,
        value: key === "date" && isChecked ? prev.date.value : "",
      },
    }));
  };

  const handleInputChange = (key) => (e) => {
    setSearchOptions((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        value: e.target.value,
      },
    }));
  };

  const handleSearch = (key) => {
    const value = searchOptions[key].value.trim();
    if (value !== "") {
      // You can trigger your API call here
    }
  };

  const handleKeyPress = (key) => (e) => {
    if (e.key === "Enter") {
      handleSearch(key);
    }
  };

  const filterNavHandler = (data) => {
    if (!data) return;
    showWarningData(data);
    let filterData = [];
    setRenderOption([]);

    if (searchOptions["number"].enabled) {
      filterData = Array.isArray(filterYearData)
        ? filterYearData.filter((item) => item.identifier == data)
        : [];
    } else if (searchOptions["date"].enabled) {
      filterData = Array.isArray(filterYearData)
        ? filterYearData.filter((item) => item.date == data)
        : [];
    }

    const selectedObject =
      filterData.length > 0
        ? {
            ...filterData[0],
            key:
              selectedType === "navTP"
                ? "T & P Notices"
                : (selectedType || "").toLowerCase(),
          }
        : {};

    if (selectedObject.identifier) {
      setSelectedPolygonId(selectedObject.identifier); // Set filter for polygon rendering
    } else {
      setSelectedPolygonId(null); // Reset if no filter found
    }

    let charts = JSON.parse(selectedObject?.charts || "[]");
    let filteredCharts = allCharts?.filter((item) => charts.includes(item.id));
    let allFilteredChartNo = filteredCharts?.map((item) => item.chartNo);
    let filteredEncs = allEncs.filter((item) =>
      allFilteredChartNo.includes(item.chartNum)
    );
    setCurrentWarningEncs(filteredEncs);
    setCurrentWarningCharts(filteredCharts);
    setCurrentWarningData(selectedObject);
    window.history.pushState({}, "", "/india-wins");
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <main className={`india-wins-wrapper ${wrapperClass}`}>
          <header>
            <div className="logo-wrapper">
              <img
                src={logo}
                alt="Indian national hydrographic office"
                width="40"
                className="img-fluid me-2"
              />
              <h1 className="title">
                Indian Warnings Information and Navigation Services
              </h1>
            </div>
            <div className="toggle-btn">
              <button
                type="button"
                className="btn p-0"
                onClick={() => {
                  setShowSidebar((prev) => !prev);
                }}
              >
                <svg
                  width="40px"
                  height="40px"
                  viewBox="0 -0.5 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.5 7.75C5.08579 7.75 4.75 8.08579 4.75 8.5C4.75 8.91421 5.08579 9.25 5.5 9.25V7.75ZM19.5 9.25C19.9142 9.25 20.25 8.91421 20.25 8.5C20.25 8.08579 19.9142 7.75 19.5 7.75V9.25ZM5.5 11.75C5.08579 11.75 4.75 12.0858 4.75 12.5C4.75 12.9142 5.08579 13.25 5.5 13.25V11.75ZM17.5 13.25C17.9142 13.25 18.25 12.9142 18.25 12.5C18.25 12.0858 17.9142 11.75 17.5 11.75V13.25ZM5.5 15.75C5.08579 15.75 4.75 16.0858 4.75 16.5C4.75 16.9142 5.08579 17.25 5.5 17.25V15.75ZM12.5 17.25C12.9142 17.25 13.25 16.9142 13.25 16.5C13.25 16.0858 12.9142 15.75 12.5 15.75V17.25ZM5.5 9.25H19.5V7.75H5.5V9.25ZM5.5 13.25H17.5V11.75H5.5V13.25ZM5.5 17.25H12.5V15.75H5.5V17.25Z"
                    fill="#000000"
                  />
                </svg>
              </button>
            </div>
          </header>
          <aside
            className="warning-control"
            ref={sidebarRef}
            onClick={width < 1024 ? handleOnBlur : null}
          >
            <div className="aside-wrapper-parent">
              <div className="aside-wrapper">
                <div className="logo-wrapper">
                  <img
                    src={logo}
                    alt="Indian national hydrographic office"
                    width="40"
                    className="img-fluid me-2"
                  />
                  <h1 className="title">
                    Indian Warnings Information and Navigation Services
                  </h1>
                  {width < 1024 ? (
                    <button
                      type="button "
                      className="btn p-0"
                      onClick={() => {
                        setShowSidebar((prev) => !prev);
                      }}
                    >
                      <svg
                        width="40px"
                        height="40px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM8.96963 8.96965C9.26252 8.67676 9.73739 8.67676 10.0303 8.96965L12 10.9393L13.9696 8.96967C14.2625 8.67678 14.7374 8.67678 15.0303 8.96967C15.3232 9.26256 15.3232 9.73744 15.0303 10.0303L13.0606 12L15.0303 13.9696C15.3232 14.2625 15.3232 14.7374 15.0303 15.0303C14.7374 15.3232 14.2625 15.3232 13.9696 15.0303L12 13.0607L10.0303 15.0303C9.73742 15.3232 9.26254 15.3232 8.96965 15.0303C8.67676 14.7374 8.67676 14.2625 8.96965 13.9697L10.9393 12L8.96963 10.0303C8.67673 9.73742 8.67673 9.26254 8.96963 8.96965Z"
                          fill="#1C274C"
                        />
                      </svg>
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <hr className="mt-1 mb-3" />
                <h2 className="warnings-heading"> Warnings</h2>
                <div className="checkbox-form-wrapper">
                  <hr />
                  <div className="d-flex mb-2">
                    <input
                      type="checkbox"
                      id="allWarnings"
                      name="allWarning"
                      value="all"
                      onChange={handleWarningToggle}
                      checked={allChecked}
                    />
                    <label htmlFor="allWarnings">All</label>
                  </div>
                  <div className="d-flex mb-2">
                    <input
                      type="checkbox"
                      id="navarea"
                      name="navarea"
                      value="navarea"
                      onChange={handleWarningToggle}
                      checked={renderOption.includes("navarea") ? true : false}
                    />
                    <label htmlFor="navarea">Navarea</label>
                  </div>
                  {ENABLE_TNP && (
                    <div className="d-flex mb-2">
                      <input
                        type="checkbox"
                        id="t_p_notices"
                        name="t_p_notices"
                        value="t_p_notices"
                        onChange={handleWarningToggle}
                        checked={
                          renderOption.includes("t_p_notices") ? true : false
                        }
                      />
                      <label htmlFor="t_p_notices">T&P Notices</label>
                    </div>
                  )}
                  <div className="d-flex mb-2">
                    <input
                      type="checkbox"
                      id="navtex"
                      name="navtex"
                      value="navtex"
                      onChange={handleWarningToggle}
                      checked={renderOption.includes("navtex") ? true : false}
                    />
                    <label htmlFor="navtex">Navtex</label>
                  </div>
                  <div className="d-flex mb-2">
                    <input
                      type="checkbox"
                      id="misc"
                      name="misc"
                      value="misc"
                      onChange={handleWarningToggle}
                      checked={renderOption.includes("misc") ? true : false}
                    />
                    <label htmlFor="misc">Miscellaneous</label>
                  </div>
                </div>
                <hr className="my-3" />
                <h2 className="warnings-heading"> Charts</h2>
                <hr className="my-3" />
                <div className="show-all-charts-wrapper">
                  <input
                    type="checkbox"
                    id="allCharts"
                    onChange={(e) => renderAllCharts(e.target.checked)}
                    checked={showAllCharts ? true : false}
                  />
                  <label htmlFor="allCharts" className="m-0">
                    Show All Charts
                  </label>
                </div>
                <hr />
                <h2 className="warnings-heading">India Wins Filters</h2>
                <hr className="my-3" />
                <div className="show-all-charts-wrapper d-block checkbox-group mt-3 checkbox-form-wrapper">
                  <div>
                    <label>
                      <input
                        type="checkbox"
                        className="me-2"
                        checked={selectedType === "NavTex"}
                        onChange={() => handleTypeChange("NavTex")}
                      />
                      NavTex
                    </label>
                  </div>
                  <div>
                    <label className="">
                      <input
                        type="checkbox"
                        className="me-2"
                        checked={selectedType === "NavArea"}
                        onChange={() => handleTypeChange("NavArea")}
                      />
                      NavArea
                    </label>
                  </div>
                  {ENABLE_TNP && (
                    <div>
                      <label className="">
                        <input
                          type="checkbox"
                          className="me-2"
                          checked={selectedType === "NAVTP"}
                          onChange={() => handleTypeChange("NAVTP")}
                        />
                        T&P Notices
                      </label>
                    </div>
                  )}
                </div>
                {selectedType && (
                  <>
                    <div className="show-all-charts-wrapper">
                      <label htmlFor="allCharts" className="m-0">
                        Search By Year
                      </label>

                      <select
                        defaultValue={selectedYear || new Date().getFullYear()}
                        onChange={handleYearChange}
                        className="ms-2"
                      >
                        {years.map((year) => (
                          <option key={year} value={year}>
                            {year}
                          </option>
                        ))}
                      </select>
                    </div>
                    {selectedYear && selectedType && (
                      <>
                        {["number", "date"].map((key) => (
                          <div
                            className="show-all-charts-wrapper d-block"
                            key={key}
                          >
                            <div className="d-flex align-items-center">
                              <input
                                type="checkbox"
                                id={`searchBy${key}`}
                                onChange={handleCheckboxChange(key)}
                                checked={searchOptions[key].enabled}
                              />
                              <label
                                htmlFor={`searchBy${key}`}
                                className="ml-2 mb-0"
                              >
                                {`Search by ${
                                  key.charAt(0).toUpperCase() + key.slice(1)
                                }`}
                              </label>
                            </div>

                            {searchOptions[key].enabled && (
                              <select
                                className="mt-2"
                                value={searchOptions[key].value}
                                onChange={(e) => {
                                  handleInputChange(key)(e);
                                  filterNavHandler(e.target.value);
                                }}
                                onBlur={() => handleSearch(key)}
                              >
                                <option value="">{`Select ${
                                  key.charAt(0).toUpperCase() + key.slice(1)
                                }`}</option>

                                {key === "number"
                                  ? Array.isArray(identifier) &&
                                    identifier.map((num, i) => (
                                      <option key={num} value={num}>
                                        {num}
                                      </option>
                                    ))
                                  : key === "date"
                                  ? Array.isArray(navDate) &&
                                    navDate.map((date, i) => (
                                      <option key={date} value={date}>
                                        {formatDate(date)}
                                        {identifier?.[i]
                                          ? ` , ${identifier[i]}`
                                          : ""}
                                      </option>
                                    ))
                                  : null}
                              </select>
                            )}
                          </div>
                        ))}
                      </>
                    )}
                  </>
                )}
                <hr />
                <div className="d-flex flex-wrap justify-content-between">
                  <div className="text-center mb-2 mr-2">
                    <button
                      type="button"
                      className="refresh-btn btn"
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      Refresh
                    </button>
                  </div>
                  <div className="text-center">
                    <a
                      href="https://hydrobharat.gov.in"
                      className="refresh-btn btn"
                    >
                      Back to Website
                    </a>
                  </div>
                </div>
                <div className="copyright-section mt-5">
                  <hr />
                  <p className="copyright-text">
                    @Copyright Government of India
                  </p>
                </div>
              </div>
            </div>
          </aside>
          <section
            className={`google-map-info-area ${hideInfo ? "toggle-info" : ""}`}
          >
            <div className="map-area toggle-info">
              <aside className="info-aside-wrapper">
                <div className="container">
                  {/* Bootstrap 4.0 Tabs */}
                  <ul
                    class="nav nav-tabs justify-content-center"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link active"
                        id="pills-home-tab"
                        data-toggle="tab"
                        data-target="#pills-home"
                        type="button"
                        role="tab"
                        aria-controls="pills-home"
                        aria-selected="true"
                      >
                        Warning Info
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="pills-profile-tab"
                        data-toggle="tab"
                        data-target="#pills-profile"
                        type="button"
                        role="tab"
                        aria-controls="pills-profile"
                        aria-selected="false"
                      >
                        Chart Info
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link"
                        id="pills-contact-tab"
                        data-toggle="tab"
                        data-target="#pills-contact"
                        type="button"
                        role="tab"
                        aria-controls="pills-contact"
                        aria-selected="false"
                      >
                        ENC Info
                      </button>
                    </li>
                  </ul>
                  <div class="tab-content text-white" id="pills-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="pills-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      {/* Warning Info */}
                      <div className="warning-info-wrapper">
                        <div className="d-flex justify-content-between">
                          <h2 className="warning-title">
                            {currentWarningData && currentWarningData.key
                              ? currentWarningData.key == "navarea"
                                ? "Navarea " + currentWarningData.identifier
                                : currentWarningData.key == "navtex"
                                ? "Navtex " + currentWarningData.identifier
                                : "T & P Notices " +
                                  currentWarningData.identifier
                              : null}
                          </h2>
                          <button
                            class="btn btn-primary cursor-pointer"
                            onClick={() =>
                              generateNavtexPdf(currentWarningData)
                            }
                          >
                            <FiDownload className="cursor-pointer" />
                          </button>
                        </div>
                        <hr />
                        {/* Date */}
                        {currentWarningData && currentWarningData.date && (
                          <div className="common-details">
                            <p>Date:</p>
                            <p>{formatDate(currentWarningData.date)}</p>
                          </div>
                        )}
                        {/* Identifier */}
                        {currentWarningData &&
                          currentWarningData.identifier && (
                            <div className="common-details">
                              <p>Identifier:</p>
                              <p>{currentWarningData.identifier}</p>
                            </div>
                          )}
                        {/* Type */}
                        {currentWarningData && currentWarningData.types && (
                          <div className="common-details">
                            <p>Type:</p>
                            <p>{currentWarningData.types}</p>
                          </div>
                        )}
                        {/* DTG */}
                        {/* {currentWarningData && currentWarningData.dtg && (
                          <div className="common-details">
                            <p>DTG:</p>
                            <p>{currentWarningData.dtg}</p>
                          </div>
                        )} */}
                        {/* B Chart */}
                        {currentWarningData && currentWarningData.b_char && (
                          <div className="common-details">
                            <p>B Chart:</p>
                            <p>{currentWarningData.b_char}</p>
                          </div>
                        )}
                        {/* General Area */}
                        {currentWarningData &&
                          currentWarningData.general_area && (
                            <div className="common-details">
                              <p>General Area:</p>
                              <p>{currentWarningData.general_area}</p>
                            </div>
                          )}
                        {/* Station */}
                        {currentWarningData && currentWarningData.station && (
                          <div className="common-details">
                            <p>Station:</p>
                            <p>{currentWarningData.station}</p>
                          </div>
                        )}
                        {/* Place */}
                        {currentWarningData && currentWarningData.place && (
                          <div className="common-details">
                            <p>Place:</p>
                            <p>{decodeHtml(currentWarningData.place)}</p>
                          </div>
                        )}
                        {/* Notice */}
                        {currentWarningData && currentWarningData.notice && (
                          <div className="common-details">
                            <p>Notice:</p>
                            <p>{decodeHtml(currentWarningData.notice)}</p>
                          </div>
                        )}

                        {/* message */}
                        {currentWarningData && currentWarningData.message && (
                          <>
                            <hr />
                            <div className="message-wrapper">
                              <h6 className="message-heading">Message:</h6>
                              <div
                                className="message-content"
                                dangerouslySetInnerHTML={{
                                  __html: currentWarningData.message,
                                }}
                              ></div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-profile"
                      role="tabpanel"
                      aria-labelledby="pills-profile-tab"
                    >
                      {/* Chart Info */}
                      <div className="warning-info-wrapper">
                        <h2 className="warning-title">
                          {currentWarningData && currentWarningData.key
                            ? currentWarningData.key == "navarea"
                              ? "Navarea " + currentWarningData.identifier
                              : currentWarningData.key == "navtex"
                              ? "Navtex " + currentWarningData.identifier
                              : "T & P Notices " + currentWarningData.identifier
                            : null}
                        </h2>
                        {currentWarningCharts &&
                          Array.isArray(currentWarningCharts) &&
                          currentWarningCharts.length > 0 &&
                          currentWarningCharts.map((item) => {
                            return (
                              <>
                                <hr />
                                <h6 className="chart-title">{item.name}</h6>
                                <div className="common-details">
                                  <p>Chart No:</p>
                                  <p>{item.chartNo}</p>
                                </div>
                                <div className="common-details">
                                  <p>Chart coordinates:</p>
                                  <p>
                                    {decodeHtml(
                                      format(item.latFrom, 1) +
                                        " || " +
                                        format(item.longFrom, 2) +
                                        " || " +
                                        format(item.latTo, 1) +
                                        " || " +
                                        format(item.longTo, 2)
                                    )}
                                  </p>
                                </div>
                                <div className="common-details">
                                  <p>Chart Scale:</p>
                                  <p>{item.scale}</p>
                                </div>
                                <div className="common-details">
                                  <p>General Area:</p>
                                  <p>{item.generalArea}</p>
                                </div>
                                <div className="common-details">
                                  <p>Year of Publication:</p>
                                  <p>{item.Dpub}</p>
                                </div>
                              </>
                            );
                          })}
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="pills-contact"
                      role="tabpanel"
                      aria-labelledby="pills-contact-tab"
                    >
                      {/* ENC Info */}
                      <div className="warning-info-wrapper">
                        <h2 className="warning-title">
                          {currentWarningData && currentWarningData.key
                            ? currentWarningData.key == "navarea"
                              ? "Navarea " + currentWarningData.identifier
                              : currentWarningData.key == "navtex"
                              ? "Navtex " + currentWarningData.identifier
                              : "T & P Notices " + currentWarningData.identifier
                            : null}
                        </h2>
                        {currentWarningEncs &&
                          Array.isArray(currentWarningEncs) &&
                          currentWarningEncs.length > 0 &&
                          currentWarningEncs.map((item) => {
                            return (
                              <>
                                <hr />
                                <h6 className="chart-title">{item.EncNum}</h6>
                                <div className="common-details">
                                  <p>ENC No:</p>
                                  <p>{item.EncNum}</p>
                                </div>
                                <div className="common-details">
                                  <p>Chart No:</p>
                                  <p>{item.chartNum}</p>
                                </div>
                                <div className="common-details">
                                  <p>ENC Name:</p>
                                  <p>{item.name}</p>
                                </div>
                                <div className="common-details">
                                  <p>ENC Coordinates:</p>
                                  <p>
                                    {decodeHtml(
                                      format(item.LatFrom, 1) +
                                        " || " +
                                        format(item.LongFrom, 2) +
                                        " || " +
                                        format(item.LatTo, 1) +
                                        " || " +
                                        format(item.LongTo, 2)
                                    )}
                                  </p>
                                </div>
                                <div className="common-details">
                                  <p>ENC Scale: </p>
                                  <p>{item.scale}</p>
                                </div>
                                <div className="common-details">
                                  <p>Category: </p>
                                  <p>{item.category}</p>
                                </div>
                                <div className="common-details">
                                  <p>Year of Publication: </p>
                                  <p>{item.Dpub}</p>
                                </div>
                              </>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
                {hideInfo ? null : (
                  <button
                    className="toggle-info-aside-btn close-btn"
                    type="button"
                    onClick={() => {
                      setHideInfo(true);
                      setSelectedType("");
                      setSearchOptions({
                        number: {
                          enabled: false,
                          value: "",
                        },
                        date: {
                          enabled: false,
                          value: "",
                        },
                      });
                      setCurrentWarningData();
                    }}
                  >
                    <IoIosArrowBack />
                  </button>
                )}
                {hideInfo &&
                (currentWarningData ||
                  currentWarningCharts ||
                  currentWarningEncs) ? (
                  <button
                    className="toggle-info-aside-btn open-btn"
                    type="button"
                    onClick={() => {
                      setHideInfo(false);
                      setSelectedType("");
                      setSearchOptions({
                        number: {
                          enabled: false,
                          value: "",
                        },
                        date: {
                          enabled: false,
                          value: "",
                        },
                      });
                    }}
                  >
                    <IoIosArrowForward />
                  </button>
                ) : null}
              </aside>
              <div className="custom-google-map-wrapper">
                {renderOption &&
                Array.isArray(renderOption) &&
                renderOption.length === 1 &&
                renderOption.includes("misc") ? null : (
                  <div className="position-relative">
                    {isLoaded ? (
                      <>
 <GoogleMap
                          mapContainerStyle={mapContainerStyle}
                          options={mapOptions}
                          onMouseMove={(e) => {
                            if (!e?.latLng) return;

                            coordsRef.current = {
                              lat: e.latLng.lat(),
                              lng: e.latLng.lng(),
                            };

                            // directly update DOM
                            const el = document.getElementById("latlng-box");
                            if (el) {
                              el.innerHTML = `Coordinate of cursor position 
                                Lat: ${coordsRef.current.lat.toFixed(6)}
                                Lon: ${coordsRef.current.lng.toFixed(6)}
                              `;
                            }
                          }}
                        >
                         <div
                            id="latlng-box"
                            style={{
                              position: "absolute",
                              bottom: "0",
                              width: "100%",
                              background: "#f5f5f5",
                              color: "#000",
                              padding: "2px 10px",
                              borderRadius: "0",
                              fontSize: "12px",
                              zIndex: "999",
                              pointerEvents: "none",
                              textAlign: "right",
                            }}
                          >
                            Move mouse on map
                          </div>
                          {/* Static Navarea VIII polyline */}

                          <PolylineF
                            path={navareaLineOne}
                            options={{
                              strokeColor: "#FF0000",
                              strokeOpacity: 1.0,
                              strokeWeight: 2,
                            }}
                          />

                          <PolylineF
                            path={navareaLineTwo}
                            options={{
                              strokeColor: "#FF0000",
                              strokeOpacity: 1.0,
                              strokeWeight: 2,
                            }}
                          />

                          {/* Points rendered */}
                          {allPoints &&
                            Array.isArray(allPoints) &&
                            allPoints.length > 0 &&
                            allPoints.map((item, ind) => {
                              if (
                                !hideInfo &&
                                currentWarningData &&
                                currentWarningData.identifier !==
                                  item.identifier
                              )
                                return;
                              return item &&
                                item.coordinates &&
                                Array.isArray(item.coordinates) &&
                                item.coordinates.length > 0
                                ? item.coordinates.map((coords, index) => {
                                    return (
                                      <MarkerF
                                        key={item.key + ind + "point" + index}
                                        title={`${
                                          item.key == "navarea"
                                            ? `Navarea Warning:`
                                            : item.key == "navtex"
                                            ? `Navtex Warning:`
                                            : `T & P Notices:`
                                        } ${item.identifier}`}
                                        position={coords}
                                        icon={{
                                          url:
                                            item.key == "navarea"
                                              ? navareaIndicator
                                              : item.key == "navtex"
                                              ? navtexIndicator
                                              : tnpIndicator,
                                        }}
                                        onClick={() => showWarningData(item)}
                                      />
                                    );
                                  })
                                : null;
                            })}

                          {/* Polygon rendered */}
                          {/* // Polygon rendering inside GoogleMap component */}
                          {allPolygon &&
                            Array.isArray(allPolygon) &&
                            allPolygon.length > 0 &&
                            allPolygon
                              // Filter polygons: show all if none selected, else show only selected polygon
                              .filter(
                                (item) =>
                                  !selectedPolygonId ||
                                  item.identifier === selectedPolygonId
                              )
                              .map((item, ind) => {
                              if (
                                !hideInfo &&
                                currentWarningData &&
                                currentWarningData.identifier !==
                                  item.identifier
                              )
                                return;
                                let title = `${
                                  item.key === "navarea"
                                    ? `Navarea Warning:`
                                    : item.key === "navtex"
                                    ? `Navtex Warning:`
                                    : `T & P Notices:`
                                } ${item.identifier}`;
                                return item &&
                                  item.coordinates &&
                                  Array.isArray(item.coordinates) &&
                                  item.coordinates.length > 0 ? (
                                  <PolygonF
                                    key={item.key + ("polygon" + ind)}
                                    paths={item.coordinates}
                                    options={{
                                      fillColor:
                                        item.key === "navarea"
                                          ? "#FF9933"
                                          : item.key === "navtex"
                                          ? "green"
                                          : "white",
                                      fillOpacity: 0.35,
                                      strokeColor:
                                        item.key === "navarea"
                                          ? "#FF9933"
                                          : item.key === "navtex"
                                          ? "green"
                                          : "white",
                                      strokeOpacity: 0.5,
                                      strokeWeight: 2,
                                      draggable: false,
                                      editable: false,
                                      geodesic: false,
                                      zIndex: 9,
                                    }}
                                    onMouseOver={function (e) {
                                      handleMouseOver(this, e, title);
                                    }}
                                    onMouseMove={(e) => moveTooltip(e)}
                                    onMouseOut={handleMouseOut}
                                    onClick={() => showWarningData(item)}
                                  />
                                ) : null;
                              })}

                          {/* Circles rendered */}
                          {allCircles &&
                            Array.isArray(allCircles) &&
                            allCircles.length > 0 &&
                            allCircles
                              .filter(
                                (item) =>
                                  !selectedPolygonId ||
                                  item.identifier === selectedPolygonId
                              )
                              .map((item, ind) => {
                              if (
                                !hideInfo &&
                                currentWarningData &&
                                currentWarningData.identifier !==
                                  item.identifier
                              )
                                return;
                                let title = `${
                                  item.key === "navarea"
                                    ? "Navarea Warning:"
                                    : item.key === "navtex"
                                    ? "Navtex Warning:"
                                    : "T & P Notices:"
                                } ${item.identifier}`;
                                return item &&
                                  item.coordinates &&
                                  Array.isArray(item.coordinates) &&
                                  item.coordinates.length > 0 ? (
                                  <CircleF
                                    key={item.key + ("circle" + ind)}
                                    center={item.coordinates[0]}
                                    options={{
                                      strokeColor:
                                        item.key == "navarea"
                                          ? "#FF9933"
                                          : item.key == "navtex"
                                          ? "green"
                                          : "white",
                                      strokeOpacity: 0.5,
                                      strokeWeight: 2,
                                      fillColor:
                                        item.key == "navarea"
                                          ? "#FF9933"
                                          : item.key == "navtex"
                                          ? "green"
                                          : "white",
                                      fillOpacity: 0.35,
                                      radius: item.radius * 1000,
                                      zIndex: 1,
                                    }}
                                    onMouseOver={function (e) {
                                      handleMouseOver(this, e, title);
                                    }}
                                    onMouseMove={(e) => moveTooltip(e)}
                                    onMouseOut={handleMouseOut}
                                    onClick={() => showWarningData(item)}
                                  />
                                ) : null;
                              })}

                          {/* Arc rendered */}
                          {allArcs &&
                            Array.isArray(allArcs) &&
                            allArcs.length > 0 &&
                            allArcs
                              .filter((arc) => !selectedPolygonId || arc.identifier === selectedPolygonId)
                              .map((data, index) => {
                                const coords = data.coordinates;
                                if (!coords || coords.length < 3) return null;
 
                                const A = coords[0];
                                const B = coords[1];
                                const C = coords[2];
 
                                const radiusMeters = parseFloat(data.radius) * 1852; // NM → meters
 
                                const arcPts = drawArc(A, bearing(A, B), bearing(A, C), radiusMeters);
 
                                // Full polygon path: A -> B -> arcPts -> C -> A
                                const fullPath = [A, B, ...arcPts, C, A];
 
                                let polygonRef = null;
 
                                return (
                                  <PolygonF
                                    key={data.key + "_arc_" + index}
                                    path={fullPath}
                                    options={{
                                      strokeColor: data.key === "navarea" ? "#FF9933" : "green",
                                      strokeOpacity: 0.8,
                                      strokeWeight: 2,
                                      fillColor: data.key === "navarea" ? "#FF9933" : "green",
                                      fillOpacity: 0.35,
                                      zIndex: 10,
                                      geodesic: true,
                                    }}
                                    onLoad={(polygon) => (polygonRef = polygon)}
                                    onMouseOver={(e) => {
                                      polygonRef?.setOptions({ fillOpacity: 0.55, strokeWeight: 4 }); // highlight
                                      injectTooltip(e, `Arc ${data.identifier}`); // show identifier
                                    }}
                                    onMouseMove={(e) => moveTooltip(e)}
                                    onMouseOut={() => {
                                      polygonRef?.setOptions({ fillOpacity: 0.35, strokeWeight: 2 }); // reset
                                      deleteTooltip();
                                    }}
                                    onClick={() => showWarningData(data)}
                                  />
                                );
                              })}

                          {/* Show All rectangles */}

                          {showAllCharts &&
                            allCharts &&
                            Array.isArray(allCharts) &&
                            allCharts.length > 0 &&
                            allCharts.map((item, index) => {
                            if (
                                !hideInfo &&
                                currentWarningData &&
                                currentWarningData.identifier !==
                                  item.identifier
                              )
                                return;
                              let title = "Chart No: " + item.chartNo;
                              return (
                                <RectangleF
                                  key={data.key + ("chart" + index)}
                                  bounds={{
                                    north: toChartCord(item.latTo),
                                    south: toChartCord(item.latFrom),
                                    east: toChartCord(item.longTo),
                                    west: toChartCord(item.longFrom),
                                  }}
                                  options={{
                                    fillColor: "#eac600",
                                    fillOpacity: 0.0001,
                                    strokeColor: "#eac600",
                                    strokeOpacity: 0.8,
                                    strokeWeight: 2,
                                  }}
                                  onMouseOver={function (e) {
                                    handleRecMouseOver(this, e, title);
                                  }}
                                  onMouseMove={(e) => moveTooltip(e)}
                                  onMouseOut={handleRecMouseOut}
                                  onClick={() => showChartsData(item)}
                                />
                              );
                            })}

                          {/* Warning based rectangle */}
                          {!hideInfo &&
                            !showAllCharts &&
                            currentWarningCharts &&
                            currentWarningCharts &&
                            Array.isArray(currentWarningCharts) &&
                            currentWarningCharts.length > 0 &&
                            currentWarningCharts.map((item, index) => {
                              let title = "Chart No: " + item.chartNo;
                              return (
                                <RectangleF
                                  key={data.key + ("chart" + index)}
                                  bounds={{
                                    north: toChartCord(item.latTo),
                                    south: toChartCord(item.latFrom),
                                    east: toChartCord(item.longTo),
                                    west: toChartCord(item.longFrom),
                                  }}
                                  options={{
                                    fillColor: "#eac600",
                                    fillOpacity: 0.0001,
                                    strokeColor: "#eac600",
                                    strokeOpacity: 0.8,
                                    strokeWeight: 2,
                                  }}
                                  onMouseOver={function (e) {
                                    handleRecMouseOver(this, e, title);
                                  }}
                                  onMouseMove={(e) => moveTooltip(e)}
                                  onMouseOut={handleRecMouseOut}
                                  onClick={() => showChartsData(item)}
                                />
                              );
                            })}
                        </GoogleMap>

                        <div className="map-warning-idicators-wrapper">
                          <h2 className="heading">
                            Indian Warnings Information and Navigation Services
                          </h2>
                          <div className="indicator-wrapper">
                            <span>
                              <img src={navareaIndicator} />
                            </span>
                            <span className="indicator-heading">Navarea</span>
                            <span className="indicator-vr"></span>
                            {ENABLE_TNP && (
                              <>
                                <span>
                                  <img src={tnpIndicator} />
                                </span>
                                <span className="indicator-heading">
                                  T & P Notices
                                </span>
                              </>
                            )}
                            <span className="indicator-vr"></span>
                            <span>
                              <img src={navtexIndicator} />
                            </span>
                            <span className="indicator-heading">Navtex</span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <Loader />
                    )}
                  </div>
                )}
                {renderOption &&
                Array.isArray(renderOption) &&
                renderOption.includes("misc") &&
                allMisc &&
                Array.isArray(allMisc) &&
                allMisc.length > 0 ? (
                  <div className="misc-warnings-wrapper">
                    <h2>All Miscellaneous Warnings</h2>
                    <table border="4" className="table-responsive">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Identifier</th>
                          <th>Place</th>
                          <th>Charts</th>
                          <th>Message</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allMisc.map((item, index) => {
                          return (
                            <tr key={"miscellaniousWarning" + index}>
                              <td>{formatDate(item.date)}</td>
                              <td>{item.identifier}</td>
                              <td>{decodeHtml(item.place)}</td>
                              <td>{JSON.parse(item.charts).join(", ")}</td>
                              <td>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.message,
                                  }}
                                ></div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : null}
              </div>
            </div>
          </section>
        </main>
      )}
    </>
  );
}

export default App;